import React, { Fragment } from 'react';
import { Card } from 'reactstrap';
import { CustomTable, TableColumn } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventProductMainReport } from '@/model/EventProductMainReport';
import { EventProductDetailReportV2 } from '@/model/EventProductDetailReportV2';

interface StateProps {
  main: EventProductMainReport;
}

export const SaleProductProductsContent: React.FC<StateProps> = ({ main }) => {
  const defaultColumns: TableColumn<any>[] = [
    {
      name: 'Produto',
      selector: row => row.productName,
    },
    {
      name: 'Vendidos',
      selector: row => row.productSold,
    },
    {
      name: 'Valor',
      selector: row => row.productValue,
    },
    {
      name: 'Venda',
      selector: row => row.totalSaleVale,
    },
    {
      name: 'Comissão',
      selector: row => row.totalCommission,
    },
    {
      name: 'Venda + comissão',
      selector: row => row.totalSaleValueWithCommission,
    },
    {
      name: 'Estoque inicial',
      selector: row => row.initialInventory,
    },
    {
      name: 'Estoque disponível',
      selector: row => row.availableStock,
    },
  ];

  const withoutStockColumns: TableColumn<any>[] = [
    {
      name: 'Produto',
      selector: row => row.productName,
    },
    {
      name: 'Vendidos',
      selector: row => row.productSold,
    },
    {
      name: 'Valor',
      selector: row => row.productValue,
    },
    {
      name: 'Venda',
      selector: row => row.totalSaleVale,
    },
    {
      name: 'Comissão',
      selector: row => row.totalCommission,
    },
    {
      name: 'Venda + comissão',
      selector: row => row.totalSaleValueWithCommission,
    },
  ];

  const getColumns = (products: EventProductDetailReportV2[]): TableColumn<any>[] => {
    let showStock = false;
    // eslint-disable-next-line no-plusplus
    for (let p = 0; p < products.length; p++) {
      if (products[p].initialInventory > 0 || products[p].availableStock > 0) {
        showStock = true;
        break;
      }
    }
    if (showStock) {
      return defaultColumns;
    }
    return withoutStockColumns;
  };
  return (
    <Fragment>
      <h6 className="mb-4 collapseTableText">Vendas geral por produto</h6>
      <hr />
      {main && main.products && main.products.length > 0 && (
        <Card
          className="mb-5 card-no-border customTableScroll"
          style={{ border: 'none', overflow: 'auto' }}
        >
          <div className="p-4">
            <h6>Vendas</h6>
            <CustomTable
              theme="secondary"
              numberRowsPerPage={0}
              progressPending={false}
              columns={getColumns(main.products)}
              data={main.products.map(data => ({
                productName: data.productName,
                productSold: data.productsSold,
                initialInventory: data.initialInventory,
                availableStock: data.availableStock,
                productValue: toCurrency(data.productValue),
                totalSaleVale: toCurrency(data.totalSaleVale),
                totalCommission: toCurrency(data.totalCommission),
                totalSaleValueWithCommission: toCurrency(data.totalSaleValueWithCommission),
              }))}
            />
          </div>
        </Card>
      )}

      {main && main.courtesies && main.courtesies.length > 0 && (
        <Card
          className="mb-5 card-no-border customTableScroll"
          style={{ border: 'none', overflow: 'auto' }}
        >
          <div className="p-4">
            <h6>Cortesias</h6>
            <CustomTable
              theme="secondary"
              numberRowsPerPage={0}
              progressPending={false}
              columns={[
                {
                  name: 'Produto',
                  selector: row => row.productName,
                },
                {
                  name: 'Quantidade',
                  selector: row => row.productSold,
                },
              ]}
              data={main.courtesies.map(data => ({
                productName: data.productName,
                productSold: data.productsSold,
              }))}
            />
          </div>
        </Card>
      )}
    </Fragment>
  );
};
